import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import {
  LinearProgress,
  Button,
  Typography,
  Stack,
  Card,
  Box,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import withAuth from "../../../../../../../Hoc/withAuth";
import { fetchTeamMembers } from "../../Teams/Services/api";
import AlertPopup from "../../../../../../../Components/Bits/AlertPopup";
import ReactAudioPlayer from "react-audio-player";
import EvaluationContentCard from "./EvaluationContentCard";
import ResultTable from "./ResultTable";
import EditEvaluationForm from "./EditEvaluationForm";
import AttachedDocuments from "../../components/AttachedDocuments";

const ViewEvaluations = ({ user }) => {
  const { id, evalID } = useParams();

  const [editEval, setEditEval] = React.useState(false);
  const [allQueues, setAllQueues] = React.useState([]);
  const [queues, setQueues] = React.useState([]);

  // console.log("User: ", user);

  // Fetch all team members
  const { data: teamMembers = [] } = useQuery(
    ["teamMembers", id],
    () => fetchTeamMembers(id).then((res) => res.data.data),
    { enabled: !!id },
  );

  const getCallRecordings = useQuery([`Recordings${evalID}`], () => {
    return axios.get(
      `${process.env.REACT_APP_API_URL}/QAInbound/admin/${evalID}/recording`,
    );
  });

  const Recordings = getCallRecordings?.data?.data?.data;

  const config = {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  };

  // Fetch all users
  const allUsers = useQuery({
    queryKey: ["all Users"],
    queryFn: () =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/teammembers/inboundAllUsers`,
        config,
      ),
  });

  const getAllQueues = useQuery({
    queryKey: ["getAllQueues"],
    queryFn: async () =>
      await axios.get(`${process.env.REACT_APP_API_URL}/QAInbound/admin`),
    onSuccess: (data) => {
      setAllQueues(
        data?.data?.data?.filter(
          (campaignQueue) => campaignQueue?.active === true,
        ),
      );
      // console.log("allQeues data: ", data);
    },
  });
  const users = allUsers?.data?.data.data;

  // Get evaluation data
  const getEvaluationByID = useQuery({
    queryKey: ["getEvaluationByID", evalID],
    queryFn: async () =>
      await axios.get(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/Evaluations/${id}/Evaluations/${evalID}`,
        config,
      ),
  });

  const updateEvaluation = useMutation({
    mutationFn: (data) =>
      axios.put(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/Evaluations/${id}/evaluations/${evalID}`,
        data,
        config,
      ),
    onSuccess: () => {
      getEvaluationByID.refetch();
    },
  });

  const evaluation = getEvaluationByID?.data?.data?.data;

  useQuery({
    queryKey: ["getQueuess", id],
    queryFn: async () =>
      await axios.get(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/campaign/callcentercampaign/${evaluation?.call_centre_campaign_id}`,
      ),
    enabled:
      !getEvaluationByID.isLoading && !!evaluation?.call_centre_campaign_id,
    onSuccess: (data) => {
      console.log("Queues data: ", data);
      setQueues(
        data?.data?.data?.filter(
          (campaignQueue) => campaignQueue?.qa_campaign?.active === true,
        ),
      );
    },
  });

  if (
    getEvaluationByID.isLoading ||
    allUsers.isLoading ||
    teamMembers.isLoading ||
    getAllQueues.isLoading ||
    getCallRecordings.isLoading
  ) {
    return <LinearProgress />;
  }

  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" sx={{ mt: 3 }}>
          View Evaluation
        </Typography>
      </Stack>
      {editEval ? (
        <Button
          variant="contained"
          color="inherit"
          onClick={() => setEditEval(false)}
        >
          Close
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          disabled={evaluation.status === "Completed" ? true : false}
          onClick={() => setEditEval(true)}
        >
          Edit Evaluation
        </Button>
      )}

      {evaluation && (
        <>
          {editEval ? (
            <EditEvaluationForm
              evaluation={evaluation}
              users={users}
              getEvaluationByID={getEvaluationByID}
              allQueues={allQueues}
              queues={queues}
            />
          ) : (
            <EvaluationContentCard evaluation={evaluation} queues={queues} />
          )}
        </>
      )}

      <AttachedDocuments
        evaluation={evaluation}
        getEvaluationByID={getEvaluationByID}
      />

      <Card>
        <Typography p={2} variant="h6" gutterBottom>
          Call Recordings
        </Typography>
        {Recordings?.map((recording, index) =>
          recording ? (
            <Box
              key={index}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={2}
            >
              <ReactAudioPlayer
                style={{ width: "800px" }}
                src={`${process.env.REACT_APP_API_URL}/QAInbound/admin/${recording.id}/recording/download`}
                controls
              />
              <Typography>{recording.name}</Typography>
            </Box>
          ) : (
            <Typography variant="subtitle1" key={index}>
              No Recording
            </Typography>
          ),
        )}
      </Card>

      {evaluation?.status !== "New" && evaluation?.status !== "Busy" && (
        <ResultTable />
      )}

      <AlertPopup
        open={updateEvaluation.isError}
        severity="error"
        message="Error updating evaluation"
      />
      <AlertPopup
        open={updateEvaluation.isSuccess}
        severity="success"
        message="Evaluation updated succesfully"
      />
    </Stack>
  );
};

export default withAuth(ViewEvaluations);
